// extracted by mini-css-extract-plugin
module.exports = {"header":"ij","headerBg":"ik"};